import React, { Component } from 'react';

/**
 * Component for showing a menu on a page.
 *
 * @extends React.Component
 */
class PageMenu extends Component {
  /** @inheritdoc */

  /** @inheritdoc */
  render() {
    return (
      <div className="col-sm-3">
        <div className="widget">
          <h3 className="section-heading">{this.props.header}</h3>
          <div className="list-group" id="list-tab" role="tablist">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

// Only allow children of type PageMenuItem.
PageMenu.propTypes = {
  children: function (props, propName, componentName) {
    var prop = props[propName];

    var violating = false;
    prop.forEach(function (child) {
      if (child && child.type.name !== 'PageMenuItem') {
        violating = true;
      }
    });
    // Only accept items of type PageMenuItem.
    if (violating) {
      return new Error(
        '`' + componentName + '` ' +
        'should only have children of the type PageMenuItem');
    }
  }
}

export default PageMenu;



// WEBPACK FOOTER //
// ./src/components/PageMenu/index.js